<template>
  <div @click="copyItem()" v-show="displayComponent">
    <v-tooltip bottom :disabled="!tooltip">
      <template v-slot:activator="{ on }">
        <span v-if="renderAsHTML" v-on="on" :class="css([])" v-html="translation"></span>
        <span v-else v-on="on" :class="css([])" ref="translatedText">{{ prepend }} {{ translation | capitalize }}
          {{ append }}</span>
      </template>
      <span ref="toCopy">{{ token }}</span>
    </v-tooltip>
  </div>
</template>

<script>
import languageLogic from '@/mixins/languageLogic'
import { copyTextOfElement } from '@/utils/copyUtils'
import { mapState } from 'pinia';
import { useTestModeStore } from '@/stores/testMode';

export default {
  mixins: [languageLogic],
  name: 'mrx-translation',
  props: {
    token: String,
    append: '',
    prepend: String,
    cssClasses: Array,
    renderAsHTML: false,
    display: { type: Boolean, default: true },
    showUntranslatedToken: { type: Boolean, default: false }
  },
  data: () => ({
    snackbar: false,
    snackbarMessage: '',
    snackbarColor: '',
    sheet: false,
    editedTranslation: null,
    grammarString: ['verb', 'noun', 'passive', 'plural'],
    showTemplate: true,
    showBaseToken: true,
    showLocalizedToken: false

  }),
  computed: {

    displayComponent() {
      return ((this.display && this.isTranslated) || this.showToken)
    },

    showToken: function () {
      return this.getMode('showTranslationTokens') || this.showUntranslatedToken
    },

    tooltip: function () {
      return this.getMode('showTranslationTokens')
    },

    referenceLanguage() {
      return 'en-US'
    },

    grammar() {
      return {
        noun: this.$t('grammar.noun.home.default'),
        passive: this.$t('grammar.passive.home.default'),
        verb: this.$t('grammar.verb.home.default'),
        plural: this.$t('grammar.plural.home.default')
      }
    },

    translation() {
      if (this.isTranslated) {
        return this.$t(this.token, this.grammar).replace(/\[.*?\]/, '').trim()
      }
      else {
        return this.showToken ? this.token : ''
      }
    },

    isTranslated() {
      return (this.$t(this.token) !== this.token && this.token && this.token.length > 0)
    },

    ...mapState(useTestModeStore, { getMode: 'get' }),
  },
  methods: {
    copyItem() {
      if (this.getMode('showTranslationTokens')) {
        copyTextOfElement(this.$refs.toCopy)
      } else {
        if (this.getMode('copyTranslation')) {
          copyTextOfElement(this.$refs.translatedText)
        }
      }
    },
    css(extra) {
      return extra.concat(this.cssClasses).join(' ')
    }
  }
}
</script>

<style scoped>
.pre {
  font-size: 1.2em;
  font-family: 'Roboto';
  line-height: 1.1em;
}

.successMessage {
  background-color: var(--success);
  padding: 3px;
  display: block;
  color: #fff;
  font-weight: bold;
  text-align: center;
}

.infoMessage {
  background-color: #0097A7;
  padding: 3px;
  display: block;
  color: #fff;
  font-weight: bold;
  text-align: center;
}

.warningMessage {
  background-color: var(--caution);
  padding: 3px;
  display: block;
  color: #424242;
  font-weight: bold;
  text-align: center;
}

.errorMessage {
  background-color: var(--danger);
  padding: 3px;
  display: block;
  color: #fff;
  font-weight: bold;
  text-align: center;
}

.none {
  color: var(--success) !important;
}

.mild {
  color: var(--success) !important;
}

.moderate {
  color: var(--warning) !important;
}

.severe {
  color: var(--danger) !important;
}

.possible {
  color: blue !important;
}

.inconclusive {
  color: blue !important;
}
</style>
